var _rect, _path, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 700,
    viewBox: "0 0 700 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 700,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.992 71.0077L70.9924 350.008L163.866 442.881L257.239 536.09L349.992 629.008L628.992 350.008L536.157 257.172L442.866 163.881L349.992 71.0077Z",
    fill: "#1F5AF6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 443.164,
    y: 164.164,
    width: 88.7772,
    height: 258.679,
    transform: "rotate(45 443.164 164.164)",
    fill: "url(#paint0_linear_1172_39146)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 88.7772,
    height: 265.305,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 257.157 536.172)",
    fill: "url(#paint1_linear_1172_39146)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 131.703,
    height: 291.446,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 443.003 164.253)",
    fill: "url(#paint2_linear_1172_39146)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 257.157,
    y: 536.172,
    width: 262.569,
    height: 301.871,
    transform: "rotate(-135 257.157 536.172)",
    fill: "url(#paint3_linear_1172_39146)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1172_39146",
    x1: 443.164,
    y1: 199.256,
    x2: 507.282,
    y2: 217.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B49C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F5AF6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1172_39146",
    x1: 7.45554e-7,
    y1: 35.9906,
    x2: 67.599,
    y2: 60.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B49C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F5AF6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1172_39146",
    x1: 0.242253,
    y1: 12.9314,
    x2: 132.83,
    y2: 152.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F5AF6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1172_39146",
    x1: 269.41,
    y1: 555.274,
    x2: 400.263,
    y2: 750.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F5AF6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwaves);
export default __webpack_public_path__ + "static/media/SWAVES.1e4d8e13298acef263babdb05987ff2b.svg";
export { ForwardRef as ReactComponent };